<div class="min-h-screen bg-gradient-to-br from-gray-50 to-amber-50/40 p-6" *ngIf="vendorId">
  <div class="max-w-5xl mx-auto space-y-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Vendor resources</h1>
      <p class="text-gray-600 text-sm">{{ companyName || 'Your company' }} — upload manpower, machines, materials and stock.</p>
    </div>

    <div class="bg-white rounded-xl border border-amber-100 shadow-sm p-4 flex flex-wrap items-end gap-4">
      <div>
        <label class="block text-xs font-semibold text-gray-600 mb-1">Overall availability</label>
        <select class="border rounded-lg px-3 py-2 text-sm" [(ngModel)]="availabilityStatus">
          <option value="available">Available</option>
          <option value="limited">Limited</option>
          <option value="unavailable">Unavailable</option>
        </select>
      </div>
      <button type="button" (click)="saveAvailability()" class="px-4 py-2 rounded-lg bg-gray-900 text-white text-sm font-medium">
        Save status
      </button>
    </div>

    <div class="flex flex-wrap gap-2">
      <button
        type="button"
        (click)="setFilter('')"
        [class]="filterType === '' ? 'bg-amber-600 text-white' : 'bg-white border'"
        class="px-3 py-1.5 rounded-lg text-sm"
      >
        All
      </button>
      <button
        type="button"
        *ngFor="let t of types"
        (click)="setFilter(t.id)"
        [class]="filterType === t.id ? 'bg-amber-600 text-white' : 'bg-white border'"
        class="px-3 py-1.5 rounded-lg text-sm"
      >
        {{ t.label }}
      </button>
    </div>

    <div class="bg-white rounded-xl border border-gray-200 shadow p-6">
      <h2 class="text-lg font-semibold mb-4">Add row</h2>
      <form [formGroup]="form" (ngSubmit)="submitRow()" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div>
          <label class="block text-xs text-gray-600 mb-1">Type</label>
          <select class="w-full border rounded-lg px-3 py-2" formControlName="resource_type">
            <option *ngFor="let t of types" [value]="t.id">{{ t.label }}</option>
          </select>
        </div>
        <div class="md:col-span-2">
          <label class="block text-xs text-gray-600 mb-1">Title / description *</label>
          <input class="w-full border rounded-lg px-3 py-2" formControlName="title" placeholder="e.g. Excavator CAT 320, Cement OPC 53, Welders x12" />
        </div>
        <div>
          <label class="block text-xs text-gray-600 mb-1">Qty / capacity</label>
          <input type="number" class="w-full border rounded-lg px-3 py-2" formControlName="quantity" />
        </div>
        <div>
          <label class="block text-xs text-gray-600 mb-1">Unit</label>
          <input class="w-full border rounded-lg px-3 py-2" formControlName="unit" placeholder="nos, MT, hours…" />
        </div>
        <div>
          <label class="block text-xs text-gray-600 mb-1">Stock on hand</label>
          <input type="number" class="w-full border rounded-lg px-3 py-2" formControlName="stock_quantity" />
        </div>
        <div>
          <label class="block text-xs text-gray-600 mb-1">Line availability</label>
          <select class="w-full border rounded-lg px-3 py-2" formControlName="availability">
            <option value="available">available</option>
            <option value="limited">limited</option>
            <option value="unavailable">unavailable</option>
          </select>
        </div>
        <div class="md:col-span-2 lg:col-span-3">
          <button type="submit" class="px-6 py-2 rounded-lg bg-amber-600 text-white font-medium hover:bg-amber-700">
            Add to list
          </button>
        </div>
      </form>
    </div>

    <div class="bg-white rounded-xl border border-gray-200 shadow overflow-hidden">
      <div *ngIf="loading" class="p-8 text-center text-gray-500">Loading…</div>
      <table *ngIf="!loading" class="min-w-full text-sm">
        <thead class="bg-gray-50 text-left text-gray-600">
          <tr>
            <th class="px-4 py-3 font-semibold">Type</th>
            <th class="px-4 py-3 font-semibold">Title</th>
            <th class="px-4 py-3 font-semibold">Qty</th>
            <th class="px-4 py-3 font-semibold">Stock</th>
            <th class="px-4 py-3 font-semibold">Availability</th>
            <th class="px-4 py-3 font-semibold"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of rows" class="border-t border-gray-100">
            <td class="px-4 py-2 capitalize">{{ r.resource_type }}</td>
            <td class="px-4 py-2">{{ r.title }}</td>
            <td class="px-4 py-2">{{ r.quantity ?? '—' }} {{ r.unit || '' }}</td>
            <td class="px-4 py-2">{{ r.stock_quantity ?? '—' }}</td>
            <td class="px-4 py-2">{{ r.availability }}</td>
            <td class="px-4 py-2 text-right">
              <button type="button" class="text-red-600 text-xs font-medium hover:underline" (click)="deleteRow(r)">Delete</button>
            </td>
          </tr>
          <tr *ngIf="rows.length === 0">
            <td colspan="6" class="px-4 py-8 text-center text-gray-500">No rows yet. Add your first resource above.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
